import { ResultCode } from '@adyen/adyen-web/dist/types/components/types'

export type SupportedResultCodes = Extract<ResultCode, 'Authorised' | 'Pending' | 'Error' | 'Refused'>

export enum ADYEN_SUPPORTED_RESULT_CODES {
    AUTHORISED = 'Authorised',
    PENDING = 'Pending',
    ERROR = 'Error',
    REFUSED = 'Refused'
}
